import { css } from '@emotion/react'

export const muiButtonOverride = css`
  border: 1px solid var(--clvn-blue-300);
  background-color: var(--clvn-blue-100);
  color: var(--clvn-blue-800);
  font-size: 12px;
  text-transform: none;
  padding: 5px 10px;
  gap: 5px;

  &:hover {
    border: 1px solid #ccd9dd;
    background-color: #eff8fd;
    color: var(--clvn-blue-800);
  }
`

export const muiPopoverOverride = css`
  & .MuiPaper-root {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    border-radius: 8px;
  }
`
